import { useState } from 'react';

export function useConstructor(callback) {
  const [value] = useState(callback);
  return value;
}
